import { colors, ModalForm } from 'modules/app/styles'
import { CurrentPlanInfo, GracePeriodDiscount, PlanSelector, PriceLabel, UnsubscribedCount } from './styles'
import { getDiscountedPrice, checkIsOnGracePeriod } from 'utils/helpers'
import ReactSwitch from 'react-switch'
import { ReactComponent as SuccessIcon } from 'assets/images/icons/success.svg'
import { CustomButton } from 'modules/auth/styles'
import client_1 from 'assets/images/logos/client_1.png'
import client_2 from 'assets/images/logos/client_2.png'
import client_3 from 'assets/images/logos/client_3.png'
import client_4 from 'assets/images/logos/client_4.png'
import { connect } from 'react-redux'
import { toggleCheckoutModal_action, toggleInvoicesModal_action, changeTab_action } from 'store/actions'
import { IntegrationBox } from 'modules/settings/styles'
import { TeamUsers } from 'modules/company/styles'
import { UncontrolledTooltip } from 'reactstrap'
import { CategoryPageOwnersAvatar } from 'modules/pages/styles'

const showUsersLimit = 3

const UnSubscribed = (props) => {
  return (
    <ModalForm className='h-100 d-flex flex-wrap flex-md-nowrap'>
      {!props.plan_loading && props.monthly.id && props.yearly.id && (
        <>
          <CurrentPlanInfo>
            <div className='title'>Billing</div>
            <div className='my-4'>
              <div className='info-label'>Current Plan</div>
              <div className='plan-name'>FREE {props.free_items_limit === 50 ? '(Legacy)' : ''} </div>
            </div>
            <div className='d-flex flex-column'>
              <UnsubscribedCount className='mb-3 mr-auto'>
                <TeamUsers className='TeamUsers'>
                  {props.members
                    .filter((m, i) => m.is_active && m.invite_status !== 'invited')
                    .filter((m, i) => i < showUsersLimit)
                    .map((member) => (
                      <div className='mr-1' id={`member${member.id}`}>
                        <CategoryPageOwnersAvatar user={member.user} style={{ marginLeft: '-15px' }} />
                        <UncontrolledTooltip target={`member${member.id}`}> {member.user?.name || member.name} </UncontrolledTooltip>
                      </div>
                    ))}
                  {props.members.filter((m) => m.is_active).length > showUsersLimit && (
                    <div className='mr-1'>
                      <CategoryPageOwnersAvatar user={{ id: 0, name: `+${props.members.length - showUsersLimit}` }} style={{ marginLeft: '-15px' }} />
                    </div>
                  )}
                </TeamUsers>
                <div className='count'>
                  <span className='font-weight-800'>{props.total_items_count}</span>/{props.free_items_limit}
                  <small>{' '}items</small>
                </div>
              </UnsubscribedCount>

              <div>
                You/Your (team) have used {props.total_items_count} of {props.free_items_limit} free items. An item is a response or page (draft or published)
              </div>
              <div className='member-count-slider'>
                <div className='fill' style={{ width: props.total_items_count >= props.free_items_limit ? '100%' : `${(props.total_items_count * 100) / props.free_items_limit}%` }}></div>
                <div className='count'>
                  {props.total_items_count}/{props.free_items_limit}
                </div>
              </div>
            </div>
            {props.membership && props.membership.invite_status === 'owned' && props.invoices.length > 0 && (
              <div>
                <CustomButton className='gray btn-sm shadow-none mt-4' onClick={() => props.toggleInvoicesModal(true)}>
                  Invoices
                </CustomButton>
              </div>
            )}
          </CurrentPlanInfo>
          <PlanSelector>
            <>
              {/* ADMIN */}
              {props.membership && props.membership.invite_status === 'owned' && (
                <>
                  {checkIsOnGracePeriod(props.isOnGracePeriod, props.subscription) && (
                    <GracePeriodDiscount>
                      Upgrade before July 1st and enjoy our
                      <br />
                      discounted early bird pricing
                    </GracePeriodDiscount>
                  )}
                  <div className='plan-title mt-0'>PRO</div>
                  <div className='text-center'>
                    Let your growing team be up to date with one
                    <br />
                    collective knowledge base. Anytime, anywhere.
                  </div>
                  <div className='plan-amount mb-2'>
                    {checkIsOnGracePeriod(props.isOnGracePeriod, props.subscription) && (
                      <>
                        {/* <div className='earlybird'>20% earlybird discount</div> */}
                        <div className='text-center'>
                          <span className='strike-through mr-3'>${getDiscountedPrice(props.plan_selected, false, props.subscription)}</span>
                          <span>${getDiscountedPrice(props.plan_selected, props.isOnGracePeriod, props.subscription)}</span>
                        </div>
                      </>
                    )}
                    {!checkIsOnGracePeriod(props.isOnGracePeriod, props.subscription) && (
                      <>
                        <span>${getDiscountedPrice(props.plan_selected, false, props.subscription)}</span>
                      </>
                    )}
                  </div>
                  <div className='text-center font-weight-600 mb-3 text-capitalize'>Per User, Per {props.plan_selected.interval}</div>
                  <div className='mb-4 d-flex align-items-center justify-content-center'>
                    <PriceLabel className={`text-right ${props.plan_selected.interval === 'month' ? 'active' : ''}`} onClick={() => props.set_plan_selected(props.monthly)}>
                      Monthly
                    </PriceLabel>
                    <ReactSwitch
                      id='pricing_plan'
                      onChange={(status) => {
                        props.set_plan_selected(status ? props.yearly : props.monthly)
                      }}
                      checked={props.plan_selected.interval === 'year'}
                      className={`reactSwitch mx-2 ${props.plan_selected.interval === 'year' ? 'on' : 'off'}`}
                      offColor='#fff'
                      onColor={colors['main-blue']}
                      offHandleColor={colors['light-blue-300']}
                      onHandleColor='#fff'
                      width={48}
                      height={24}
                      handleDiameter={18}
                      uncheckedIcon={false}
                      checkedIcon={false}
                    />
                    <PriceLabel className={props.plan_selected.interval === 'year' ? 'active' : ''} onClick={() => props.set_plan_selected(props.yearly)}>
                      Yearly <small>(save 20%)</small>
                    </PriceLabel>
                  </div>
                  <CustomButton
                    className='black mb-5'
                    style={{ padding: '14px 36px' }}
                    disabled={props.isSubmittingSubscription || props.isSubmittingCard}
                    onClick={() => props.toggleCheckoutModal(true)}>
                    Subscribe to PRO {props.plan_selected.interval === 'month' ? 'Monthly' : 'Annually'}
                  </CustomButton>
                  <div className='plan-group'>
                    <ul className='plan-specs'>
                      <li className='d-flex align-items-center'>
                        <SuccessIcon />
                        <span>Unlimited items</span>
                      </li>
                      <li className='d-flex align-items-center'>
                        <SuccessIcon />
                        <span>Unlimited AI responses</span>
                      </li>
                      <li className='d-flex align-items-center'>
                        <SuccessIcon />
                        <span>Response shortcuts</span>
                      </li>
                      <li className='d-flex align-items-center'>
                        <SuccessIcon />
                        <span>100GB team storage</span>
                      </li>
                    </ul>
                    <ul className='plan-specs'>
                      <li className='d-flex align-items-center'>
                        <SuccessIcon />
                        <span>Unlimited members</span>
                      </li>
                      <li className='d-flex align-items-center'>
                        <SuccessIcon />
                        <span>External sharing</span>
                      </li>
                      <li className='d-flex align-items-center'>
                        <SuccessIcon />
                        <span>Premium support</span>
                      </li>
                    </ul>
                  </div>

                  <div className='clients mt-xxl-auto'>
                    <div className='text-center'>Used by customer support and sales teams at</div>
                    <div className='logos d-flex align-items-center justify-content-around justify-content-md-between flex-wrap flex-md-nowrap'>
                      <img src={client_1} className='mx-3 mx-md-0' alt='Sobeys' />
                      <img src={client_2} className='mx-3 mx-md-0' alt='Amazon' />
                      <img src={client_3} className='mx-3 mx-md-0' alt='vimeo' />
                      <img src={client_4} className='mx-3 mx-md-0' alt='SAP' />
                    </div>
                  </div>
                </>
              )}

              {/* MEMBER */}
              {props.membership && props.membership.invite_status !== 'owned' && (
                <IntegrationBox className='my-auto' style={{ width: 400, height: 'auto' }}>
                  <div className='content'>
                    <div>
                      Sorry, you don't have permission to view this page.
                      <br />
                      You can contact the{' '}
                      <a
                        href='/'
                        className='font-weight-600'
                        onClick={(e) => {
                          e.preventDefault()
                          props.changeTab('team_members')
                        }}>
                        owner
                      </a>{' '}
                      to upgrade the plan 🙂
                    </div>
                  </div>
                </IntegrationBox>
              )}
            </>
          </PlanSelector>
        </>
      )}
    </ModalForm>
  )
}

const mapStateToProps = (state) => ({
  membership: state.auth.user.membership,
  members: state.company.company.members,
  isOnGracePeriod: state.company.company.isOnGracePeriod,
  isSubmittingSubscription: state.subscription.isSubmittingSubscription,
  isSubmittingCard: state.subscription.isSubmittingCard,
  subscription: state.subscription.subscription,
  is_subscribed: state.subscription.is_subscribed,
  invoices: state.subscription.invoices,
  free_items_limit: state.company.company.free_items_limit,
  total_items_count: state.app.total_items_count
})

const mapDispatchToProps = (dispatch) => ({
  toggleCheckoutModal: (value) => dispatch(toggleCheckoutModal_action(value)),
  toggleInvoicesModal: (value) => dispatch(toggleInvoicesModal_action(value)),
  changeTab: (value) => dispatch(changeTab_action(value))
})

export default connect(mapStateToProps, mapDispatchToProps)(UnSubscribed)
